import { render, staticRenderFns } from "./NavSubHeading.vue?vue&type=template&id=020b9299"
import script from "./NavSubHeading.vue?vue&type=script&lang=js"
export * from "./NavSubHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports